import { IntConditions, IntEnumConditions, StringConditions } from '../../../grid/gridFilters/types';
import { TimeRange } from '@nirvana/shared/dtos/types/shared/time';

export enum MaintenanceWindowsEvents {
  ADD_MAINTENANCE_WINDOW = 'addMaintenanceWindow',
  REFRESH_COMPONENT = 'refreshMaintenanceWindowComponent',
  RELOAD_GRID = 'reloadMaintenanceWindowGrid',
  SHOW_ALL_PATCHES = 'showAllPatches',
  SHOW_SECURITY_PATCHES = 'showSecurityPatches',
  SHOW_NON_SECURITY_PATCHES = 'showNonSecurityPatches',
  SHOW_MANUALLY_APPROVED_PATCHES = 'showManuallyApprovedPatches',
}

export interface ActiveSchedules {
  scanPatchesSettings?: object;
  securityPatchesSettings?: object;
  nonSecurityPatchesSettings?: object;
  manuallyApprovedPatchesSettings?: object;
}

export enum Recurrence {
  IMMEDIATELY,
  DAILY,
  WEEKLY,
  MONTHLY,
}

export enum Days {
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
}

export enum Column {
  WINDOW_NAME,
  TYPE,
  STATUS,
  SCHEDULE_DETAILS,
  LAST_MODIFIED,
  LAST_EDITED_BY,
  PERMISSIONS,
  IN_POLICIES,
}

export enum ColumnKeys {
  WINDOW_NAME = 'name',
  TYPE = 'type',
  STATUS = 'status',
  SCHEDULE_DETAILS = 'specifics',
  LAST_MODIFIED = 'lastModified',
  LAST_EDITED_BY = 'lastEditedByFullName',
  PERMISSIONS = 'allowChangeByOtherUsers',
  IN_POLICIES = 'inPolicies',
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface Filter {
  name?: StringConditions;
  status?: IntEnumConditions;
  lastModified?: DateConditions;
  lastEditedByFullName?: StringConditions;
  allowChangeByOtherUsers?: IntEnumConditions;
}

export interface DateConditions {
  timeRange?: TimeRange;
}

export const FILTERS = [
  { name: { contains: '' } },
  { status: { in: [] } },
  { lastModified: { timeRange: '' } },
  { lastEditedByFullName: { contains: '' } },
  { allowChangeByOtherUsers: { in: [] } },
];

export enum Type {
  PATCH_MANAGEMENT = 0,
}

export enum Status {
  USED = 0,
  UNUSED = 1,
  PENDING = 2,
}

export enum Permissions {
  FALSE = 0,
  TRUE = 1,
}

export const COLUMNS = [0, 2, 3, 4, 5, 6, 7];

// if this array holds all column keys then "more" filter dropdown will be empty
export const PREDEFINED_FILTERS_KEYS = [
  ColumnKeys.WINDOW_NAME,
  ColumnKeys.STATUS,
  ColumnKeys.LAST_MODIFIED,
  ColumnKeys.LAST_EDITED_BY,
];

export interface DataGridItem {
  name?: string;
  type?: Type;
  status?: Status;
  scheduleDetails?: string;
  lastModified?: string;
  lastEditedByFullName?: string;
  permissions?: boolean;
  inPolicies?: string;
}

export interface GetDataGridItemsResponse {
  rawEvents: Array<DataGridItem>;
}
